import store from './../store/store';
import Mixin from './../utils/mixin';

let Login = () => import('../pages/auth/Login');
let DirectLogin = () => import('../pages/auth/DirectLogin');
let Registration = () => import('../pages/auth/Registration');
let ForgotPassword = () => import('../pages/auth/ForgotPassword');
let NewPassword = () => import('../pages/auth/NewPassword');
let VerifyAccount = () => import('../pages/auth/VerifyAccount');

export default [
    {
        path: '/user/login',
        component: Login,
        name: 'Login',
        meta: { requiresAuth: false },
        beforeEnter: (to, from, next) => {
            if (!to.query.shop_id) {
                const defaultSlug = window.shopSetting?.defaultShopSlug;
                if (defaultSlug) {
                    next({ name: 'Login', query: { ...to.query, shop_id: defaultSlug } });
                } else {
                    next({ name: '404' });
                }
            } else {
                next();
            }
        },
    },
    {
        path: '/user/logout',
        name: 'Logout',
        meta: { requiresAuth: true },
        beforeEnter: async (to, from, next) => {
            const shopSlug = store.getters['auth/currentUserShopSlug'] || window.shopSetting?.defaultShopSlug;
            const shopTheme = store.getters['auth/shopTheme'];
            try { await Mixin.methods.call_api('post', 'auth/logout'); } catch (_) {}
            store.dispatch('cart/resetCart');
            store.dispatch('wishlist/resetWishlist');
            store.dispatch('auth/logout');
            // next(false) 대신 window.location으로만 이동 — next(false)는 from 라우트를 재평가해
            // auth 초기화 후 requiresAuth 경로에서 shop_id 없는 Login → 404 경유 문제를 유발한다.
            if (shopTheme === 'type_5' || shopTheme === 'type_6') {
                window.location.href = shopSlug ? `/${shopSlug}` : '/';
            } else {
                window.location.href = shopSlug ? `/user/login?redirect=/${shopSlug}&shop_id=${shopSlug}` : '/user/login';
            }
        },
    },
    {
        path: '/user/direct_login',
        component: DirectLogin,
        name: 'DirectLogin',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/registration',
        component: Registration,
        name: 'Registration',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/forgot-password',
        component: ForgotPassword,
        name: 'ForgotPassword',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/new-password',
        component: NewPassword,
        name: 'NewPassword',
        meta: { requiresAuth: false },
    },
    {
        path: '/user/verify-account',
        component: VerifyAccount,
        name: 'VerifyAccount',
        meta: { requiresAuth: false },
    },
];
